module.exports = __webpack_public_path__ + "img/logo.cc7cf8bb.png";